// Diagnosis utility functions - stub implementations
// These are temporary implementations to maintain compatibility

export const downloadScript = async (items, signature, clinicDetails, patientData) => {
  console.warn('downloadScript function needs to be implemented for your specific API')
  // Return a placeholder URL or base64 string
  return 'data:application/pdf;base64,placeholder'
}

export const downloadReferralLetter = async (data) => {
  console.warn('downloadReferralLetter function needs to be implemented for your specific API')
  return 'data:application/pdf;base64,placeholder'
}

export const downloadSickLeave = async (data) => {
  console.warn('downloadSickLeave function needs to be implemented for your specific API')
  return 'data:application/pdf;base64,placeholder'
}

// PDF Generation enums
export const pdfGenerationEnums = {
  profileKeys: {
    PATIENTS: 'patients'
  },
  routeKeys: {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete'
  }
}

export default {
  downloadScript,
  downloadReferralLetter,
  downloadSickLeave,
  pdfGenerationEnums
}
